import { useEffect, useState } from 'react';

import { checkUserIsConnectedOnStart } from '@/domain/auth/actions/check-user-connected-on-start.action';
import { getImpactEssQuestions } from '@/domain/impact-ess/actions/get-impact-ess-questions.action';
import { getImpactEssResponses } from '@/domain/impact-ess/actions/get-impact-ess-responses.action';
import { submitImpactEssResponse } from '@/domain/impact-ess/actions/submit-impact-ess-response.action';
import {
  selectImpactEssQuestions,
  selectImpactEssResponses,
} from '@/domain/impact-ess/impact-ess.selectors';
import { getProjectFestival } from '@/domain/project-festival/actions/get-project-festival.action';
import { getProjectsFestival } from '@/domain/project-festival/actions/get-projects-festival.action';
import { selectProjectFestivalItems } from '@/domain/project-festival/project-festival.selectors';
import { FSPrimaryButton } from '@/ui/components/button/FSPrimaryButton';
import { useAppDispatch, useAppSelector } from '@/ui/hook/store';
import { ESSQuiz } from '@/ui/pages/app/components/quiz-panel/ess/ESSQuiz';
import { ImpactQuestionContext } from '@/ui/pages/app/components/quiz-panel/ImpactQuestionContext';
import { essFestivalQuizLayout } from '@/ui/pages/app/project/festival/utils/festival-ess-quiz-layout';

export function DevNewFormESSEnv() {
  const dispatch = useAppDispatch();

  const [projectId, setProjectId] = useState<number>(-1);

  useEffect(() => {
    const runAsync = async () => {
      await dispatch(checkUserIsConnectedOnStart());
      await dispatch(getProjectsFestival());
    };
    runAsync();
  }, [dispatch]);

  const projects = useAppSelector(selectProjectFestivalItems);

  useEffect(() => {
    if (projects.length > 0) {
      setProjectId(projects[0].id);
    }
  }, [projects]);

  useEffect(() => {
    if (projectId !== -1) {
      dispatch(getProjectFestival(projectId));
      dispatch(getImpactEssQuestions({}));
      dispatch(getImpactEssResponses({ projectId }));
    }
  }, [projectId, dispatch]);

  const answers = useAppSelector(selectImpactEssQuestions);
  const responses = useAppSelector(selectImpactEssResponses);

  return (
    <div>
      <div style={{ height: 100, overflowY: 'auto' }}>
        <code>{JSON.stringify(answers, null, 2)}</code>
      </div>
      <hr />
      <div style={{ height: 100, overflowY: 'auto' }}>
        <code>{JSON.stringify(responses, null, 2)}</code>
      </div>
      <hr />
      <FSPrimaryButton
        onClick={() =>
          dispatch(
            submitImpactEssResponse({
              projectId: projectId,
              response: { id: -1, paramId: 'ESS_1', value: '89' },
            }),
          )
        }
      >
        SUBMIT ESS_1 = 89
      </FSPrimaryButton>
      <FSPrimaryButton
        onClick={() =>
          dispatch(
            submitImpactEssResponse({
              projectId: projectId,
              response: { id: -1, paramId: 'ESS_2', value: '87' },
            }),
          )
        }
      >
        SUBMIT ESS_2 = 87
      </FSPrimaryButton>
      <FSPrimaryButton
        onClick={() =>
          dispatch(
            submitImpactEssResponse({
              projectId: projectId,
              response: { id: -1, paramId: 'ESS_2', value: '7' },
            }),
          )
        }
      >
        SUBMIT ESS_2 = 7
      </FSPrimaryButton>
      <FSPrimaryButton
        onClick={() =>
          dispatch(
            submitImpactEssResponse({
              projectId: projectId,
              response: { id: -1, paramId: 'ESS_1', value: '15' },
            }),
          )
        }
      >
        SUBMIT ESS_1 = 15
      </FSPrimaryButton>
      <FSPrimaryButton
        onClick={() =>
          dispatch(
            submitImpactEssResponse({
              projectId: projectId,
              response: { id: -1, paramId: 'ESS_1', value: '' },
            }),
          )
        }
      >
        SUBMIT ESS_1 = -
      </FSPrimaryButton>
      <hr />
      <ImpactQuestionContext.Provider
        value={{ panelOpen: true, hideCompleted: false }}
      >
        <ESSQuiz essQuizLayout={essFestivalQuizLayout} />
      </ImpactQuestionContext.Provider>
    </div>
  );
}
